import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import SchemaOrg from "@/components/base/SchemaOrg";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import FeaturedArticles from "./components/FeaturedArticles";
import FAQSection from "./components/FAQSection";
import NewsletterSection from "./components/NewsletterSection";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebSite"
        data={{
          name: "华丽的外出",
          url: "https://www.hualidewaichu.com",
          description: "从穿搭到妆容，从配饰到仪态，全方位打造令人过目难忘的出行风格。",
          inLanguage: "zh-CN",
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: "华丽的外出",
          url: "https://www.hualidewaichu.com",
          description: "专注于女性出行穿搭与生活方式的高端内容平台",
          email: "contact@hualidewaichu.com",
          sameAs: [
            "https://weixin.qq.com",
            "https://xiaohongshu.com",
          ],
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              "@type": "Question",
              name: "如何判断自己的穿搭风格？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "判断穿搭风格可以从三个方面入手：首先，观察你日常最喜欢穿的单品和最常参考的时尚博主风格；其次，考虑你的职业场景和生活习惯；最后，尝试建立风格关键词，围绕关键词构建你的衣橱。",
              },
            },
            {
              "@type": "Question",
              name: "日常通勤如何穿出高级感？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "日常通勤穿出高级感的关键在于面料、剪裁和配色。选择质感好的天然面料，搭配合身剪裁的基础款单品。颜色上以中性色为主，用一件质感配饰作为造型的点睛之笔。",
              },
            },
            {
              "@type": "Question",
              name: "小个子女生如何穿出气场？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "小个子女生可以通过打造高腰线、选择同色系穿搭、选择尖头鞋以及避免过于宽大的单品来增强气场。气场不是身高决定的，而是自信和品味的外在体现。",
              },
            },
            {
              "@type": "Question",
              name: "配饰搭配有哪些基本原则？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "配饰搭配有三个核心原则：三点原则（同时佩戴的显眼配饰不超过三件）、材质统一（金属色保持统一）、场合匹配（日常低调精致，正式场合设计感更强）。",
              },
            },
          ],
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategorySection />
          <FeaturedArticles />
          <FAQSection />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
}